// extracted by mini-css-extract-plugin
export var cardHeader = "_ft-0";
export var reorderHandle = "_ft-3";
export var titleArea = "_ft-1";
export var titleAreaWithHandle = "_ft-2";